// extracted by mini-css-extract-plugin
export default {"root":"registration_root__--3o9","checkBox":"registration_checkBox__gGR5L"};